import { Typography } from "@mui/material";
import React from "react";

const NotFound: React.FC = () => {
  return (
    <Typography variant="h4" align="center">
      Page Not Found
    </Typography>
  );
};

export default NotFound;
